import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { bool, func, number } from 'prop-types';
import { ButtonContainer, FilledIcon, EmptyIcon } from './add-wishlist-button.styles';

function AddWishlistButton(_ref) {
  let {
    active,
    onClick,
    width,
    height
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["active", "onClick", "width", "height"]);

  return /*#__PURE__*/React.createElement(ButtonContainer, _extends({
    "data-testid": "add-wishlist-button",
    onClick: onClick
  }, props), active ? /*#__PURE__*/React.createElement(FilledIcon, {
    "data-testid": "filled-icon",
    width: width,
    height: height
  }) : /*#__PURE__*/React.createElement(EmptyIcon, {
    "data-testid": "empty-icon",
    width: width,
    height: height
  }));
}

AddWishlistButton.defaultProps = {
  active: false,
  width: 20,
  height: 20
};
process.env.NODE_ENV !== "production" ? AddWishlistButton.propTypes = {
  active: bool,
  onClick: func.isRequired,
  width: number,
  height: number
} : void 0;
export default AddWishlistButton;